import React, { useState, useEffect } from "react";
import { InboxOutlined, EnvironmentOutlined } from "@ant-design/icons";
import ProductSpecManager from "./product/ProductSpecManager";
import EnvironmentSpecManager from "./environment/EnvironmentSpecManager";
import { SPEC_TYPE, canViewSpecManager } from "./utils/utils";
import "./SpecManager.css";
import "./SpecManagerDashboardWrapper.css";

const DASHBOARD_SPEC_TAB_CONFIG = [
  { key: SPEC_TYPE.PRODUCT, label: "Product", icon: <InboxOutlined /> },
  { key: SPEC_TYPE.ENVIRONMENT, label: "Environment", icon: <EnvironmentOutlined /> },
];

/**
 * Inline dashboard shell for ESV Spec Manager (CocWo ESV Specs tab).
 * Contained by CocWoTabs__embeddedPanel — width and scroll stay inside the right panel.
 */
const INITIAL_DASHBOARD_SPEC_TYPE = SPEC_TYPE.PRODUCT;

export default function SpecManagerDashboardWrapper({ customer }) {
  const [activeSpecType, setActiveSpecType] = useState(INITIAL_DASHBOARD_SPEC_TYPE);
  const [isChildEditing, setIsChildEditing] = useState(false);
  const customerAccountId = customer && customer.customer_id;
  const customerCompany = customer && customer.company;

  useEffect(() => {
    if (!customerAccountId) return;
    setActiveSpecType(INITIAL_DASHBOARD_SPEC_TYPE);
    setIsChildEditing(false);
  }, [customerAccountId, customerCompany]);

  if (!canViewSpecManager() || !customerAccountId) {
    return null;
  }

  const specManagerInstanceKey = `${customerAccountId}-${customerCompany}`;

  return (
    <div className="SpecManagerDashboardWrapper">
      {!isChildEditing && (
        <div className="SpecManagerDashboardWrapper_Tabs SpecManager_Tabs">
          {DASHBOARD_SPEC_TAB_CONFIG.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`SpecManager_TabButton${activeSpecType === tab.key ? " SpecManager_TabButton--active" : ""}`}
              onClick={() => setActiveSpecType(tab.key)}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      )}
      <div className="SpecManagerDashboardWrapper_Body">
        {activeSpecType === SPEC_TYPE.ENVIRONMENT ? (
          <EnvironmentSpecManager
            key={specManagerInstanceKey}
            customer={customer}
            onEditModeChange={setIsChildEditing}
          />
        ) : (
          <ProductSpecManager
            key={specManagerInstanceKey}
            customer={customer}
            onEditModeChange={setIsChildEditing}
          />
        )}
      </div>
    </div>
  );
}
